import { NavLink } from "react-router-dom";
import { BarChart3, Users, CreditCard, ChevronLeft, ChevronRight, UserPlus, Calculator, ShieldAlert } from "lucide-react";
import { cn } from "@/lib/utils";
import { useState } from "react";

const navItems = [
  {
    label: "Portfolio Health",
    path: "/",
    icon: CreditCard,
  },
  {
    label: "Risk Score & Class",
    path: "/risk-score",
    icon: Users,
  },
  {
    label: "Capacity Planning",
    path: "/capacity-planning",
    icon: BarChart3,
  },
  {
    label: "Onboarding",
    path: "/onboarding",
    icon: UserPlus,
  },
  {
    label: "Risk Simulator",
    path: "/risk-simulator",
    icon: Calculator,
  },
  {
    label: "Fraud Intelligence",
    path: "/fraud-intelligence",
    icon: ShieldAlert,
  },
];

export const Sidebar = () => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <aside
      className={cn(
        "fixed left-0 top-0 h-screen bg-[#502D3C] flex flex-col z-50 transition-all duration-300",
        collapsed ? "w-16" : "w-56"
      )}
      data-testid="sidebar"
    >
      {/* Logo */}
      <div className="p-4 border-b border-[#6B3D4D]">
        <div className="flex items-center gap-3">
          {collapsed ? (
            <div className="w-8 h-8 bg-[#FFCC1C] rounded-md flex items-center justify-center">
              <span className="text-[#502D3C] font-bold text-lg">R</span>
            </div>
          ) : (
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-[#FFCC1C] rounded-md flex items-center justify-center">
                <span className="text-[#502D3C] font-bold text-lg">R</span>
              </div>
              <span className="text-white text-lg font-semibold tracking-tight">rippling</span>
            </div>
          )}
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-3 space-y-1" data-testid="sidebar-nav">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              cn(
                "flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors duration-150",
                isActive
                  ? "bg-[#FFCC1C] text-[#502D3C]"
                  : "text-[#E8D5DB] hover:bg-[#6B3D4D] hover:text-white"
              )
            }
            data-testid={`nav-${item.path === "/" ? "portfolio-health" : item.path.replace("/", "")}`}
          >
            <item.icon className="h-5 w-5 flex-shrink-0" />
            {!collapsed && <span className="whitespace-nowrap">{item.label}</span>}
          </NavLink>
        ))}
      </nav>

      {/* Collapse Toggle */}
      <div className="p-3 border-t border-[#6B3D4D]">
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="w-full flex items-center justify-center gap-2 px-3 py-2 rounded-lg text-[#E8D5DB] hover:bg-[#6B3D4D] hover:text-white transition-colors duration-150"
          data-testid="sidebar-toggle"
        >
          {collapsed ? (
            <ChevronRight className="h-5 w-5" />
          ) : (
            <>
              <ChevronLeft className="h-5 w-5" />
              <span className="text-sm">Collapse</span>
            </>
          )}
        </button>
      </div>
    </aside>
  );
};
